export const situacaoAplicacaoEnum = {
    APLICADA: "Aplicada",
    FINALIZADA: "Finalizada",
    CANCELADA: "Cancelada",
    ESTORNADA: "Estornada"
};

export const situacaoAplicacaoLabelEnum = {
    [situacaoAplicacaoEnum.APLICADA]: "Vacinado",
    [situacaoAplicacaoEnum.FINALIZADA]: "Finalizado",
    [situacaoAplicacaoEnum.ESTORNADA]: "Cancelado"
};
